module.exports = __webpack_public_path__ + "static/img/about1.75698c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about1.jpg
// module id = KpKA
// module chunks = 1